"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { makeVar, ReactiveVar } from "@apollo/client"

import {
  LEADER_ACTIVE_STATE,
  LEADER_COHORT_DETAIL_OVERVIEW_TAB,
  LEADER_COHORT_DETAIL_MEETINGS_TAB,
  LEADER_COHORT_DETAIL_MEMBERS_TAB_SUB_TAB_CONFIRMED_MEMBERS_TAB,
  LEADER_COHORT_DETAIL_MEETINGS_TAB_SUB_TAB_NEXT_MEETING,
  LEADER_GROUP_DETAIL_OVERVIEW_TAB,
  LEADER_DASHBOARD_GROUPS_TAB,
  LEADER_DASHBOARD_GROUPS_TAB_PUBLISHED_SUB_TAB,
  LEADER_DASHBOARD_SCHEDULE_TAB_NEXT_MEETING_SUB_TAB,
  LEADER_DASHBOARD_TODO_TAB_SEAT_REQUESTS_SUB_TAB,
  LEADER_COHORT_DETAIL_OVERVIEW_TAB_SUB_TAB_OVERVIEW,
  MEMBER_COHORT_PAGE_NEXT_SESSIONS_TAB,
} from "../../lib/constants"

export type SnackbarMessageState = {
  message: string
  duration: number
}

type TabState = {
  subTab: string | null
}

type LeaderSessionDetailPageState = {
  dialogOpen: boolean
}

type LeaderCohortDetailPageState = {
  dialogOpen: boolean
  tab: string
  todosTab: TabState
  meetingsTab: { subTab: string }
  membersTab: { subTab: string }
  overviewTab: { subTab: string }
  consultationSeatRequestCohortUserId: number | null
  viewCohortUserId: number | null
}

type LeaderGroupDetailPageState = {
  dialogOpen: boolean
  tab: string
}

type LeaderDashboardPageState = {
  dialogOpen: boolean
  tab: string
  groupsTab: { subTab: string }
  scheduleTab: { subTab: string }
  todosTab: { subTab: string }
}

type MemberCohortDetailPageState = {
  tab: string
}

export const successMessageVar: ReactiveVar<SnackbarMessageState | null> =
  makeVar(null)
export const warningMessageVar: ReactiveVar<SnackbarMessageState | null> =
  makeVar(null)
export const errorMessageVar: ReactiveVar<SnackbarMessageState | null> =
  makeVar(null)
export const isSigningInVar: ReactiveVar<boolean> = makeVar(false)

export const signUpEmailVar: ReactiveVar<string | null> = makeVar(null)
export const isViewWebsiteAsMemberOrLeaderVar: ReactiveVar<string> =
  makeVar(LEADER_ACTIVE_STATE)

export const leaderSessionDetailPageVars: ReactiveVar<LeaderSessionDetailPageState> =
  makeVar<LeaderSessionDetailPageState>({ dialogOpen: false })
export const leaderCohortDetailPageVars: ReactiveVar<LeaderCohortDetailPageState> =
  makeVar<LeaderCohortDetailPageState>({
    dialogOpen: false,
    tab: LEADER_COHORT_DETAIL_MEETINGS_TAB,
    todosTab: { subTab: null },
    meetingsTab: {
      subTab: LEADER_COHORT_DETAIL_MEETINGS_TAB_SUB_TAB_NEXT_MEETING,
    },
    membersTab: {
      subTab: LEADER_COHORT_DETAIL_MEMBERS_TAB_SUB_TAB_CONFIRMED_MEMBERS_TAB,
    },
    overviewTab: { subTab: LEADER_COHORT_DETAIL_OVERVIEW_TAB_SUB_TAB_OVERVIEW },
    consultationSeatRequestCohortUserId: null,
    viewCohortUserId: null,
  })
export const leaderGroupDetailPageVars: ReactiveVar<LeaderGroupDetailPageState> =
  makeVar<LeaderGroupDetailPageState>({
    dialogOpen: false,
    tab: LEADER_COHORT_DETAIL_OVERVIEW_TAB,
  })
export const leaderDashboardPageVars: ReactiveVar<LeaderDashboardPageState> =
  makeVar<LeaderDashboardPageState>({
    dialogOpen: false,
    tab: LEADER_DASHBOARD_GROUPS_TAB,
    groupsTab: {
      subTab: LEADER_DASHBOARD_GROUPS_TAB_PUBLISHED_SUB_TAB,
    },
    scheduleTab: {
      subTab: LEADER_DASHBOARD_SCHEDULE_TAB_NEXT_MEETING_SUB_TAB,
    },
    todosTab: {
      subTab: LEADER_DASHBOARD_TODO_TAB_SEAT_REQUESTS_SUB_TAB,
    },
  })

export const memberCohortDetailPageVars: ReactiveVar<MemberCohortDetailPageState> =
  makeVar<MemberCohortDetailPageState>({
    tab: MEMBER_COHORT_PAGE_NEXT_SESSIONS_TAB,
  })
